module.exports = __webpack_public_path__ + "static/media/tipalimentacion.976440b1.svg";